import * as Sentry from "@sentry/browser";
import { isDev, isStorybook } from "shared/constants/Environment";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (!isDev && !isStorybook) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ["localhost"],
  });
}

export const logError: typeof Sentry.captureException = (
  exception,
  captureContext,
) => {
  // eslint-disable-next-line no-console
  console.error(exception);
  return Sentry.captureException(exception, captureContext);
};

export const logWarning: typeof Sentry.captureMessage = (
  message,
  captureContext,
) => {
  console.warn(message);
  return Sentry.captureMessage(message, captureContext);
};

export const logMessage: typeof Sentry.captureMessage = (
  message,
  captureContext,
) => {
  console.info(message);
  return Sentry.captureMessage(message, captureContext);
};
